"use client";
import {JSX} from "react";
import Button from "@@/components/ui/Button";
import ProgressiveImage from "@@/utils/ProgressiveImage";
import {StaticImageData} from "next/image";
import useAppearOnScroll from "@@/hooks/useAppearsOnScroll";
import { exo2SemiBold } from "@@/utils/fonts";

interface Props {
    title: string;
    cta: string;
    ctaUrl?: string;
    sectionId?: string;
    className?: string;
    img?: StaticImageData;
    img4k?: StaticImageData;
    imgAlt?: string;
}

export default function HeroSection({ title, cta, sectionId, img, img4k, className, imgAlt, ctaUrl }: Props): JSX.Element {

    const contentAnim = useAppearOnScroll<HTMLDivElement>({
        from: "fromBottom",
        duration: 1000,
        delay: 300,
        offset: 0
    });

    return (
        <section className={`px-11 position-relative py-5 h-fit ${className}`} id={sectionId}>
            <div ref={contentAnim.ref} className={`z-2 center d-flex flex-column justify-center gap-2 ${contentAnim.className}`} style={contentAnim.style}>
                <h2 style={{color: 'var(--grey-000)'}} className={`${exo2SemiBold.className} fs-2`} dangerouslySetInnerHTML={{__html: title}}></h2>
                <Button href={ctaUrl || ''} title={cta} bgColor={`var(--blue-300)`}></Button>
            </div>
            {img && img4k ? (
                <ProgressiveImage
                    lowSrc={img}
                    highSrc={img4k}
                    alt={imgAlt || ''}
                    classLowRes={`df`}
                    width={img4k.width}
                    height={img4k.height}
                    quality={60}
                    className={`position-absolute bg-blue-transparent top-0 left-0 w-100 h-100-with-img z--1`}
                ></ProgressiveImage>
            ) : (
                <span className={`position-absolute bg-blue top-0 left-0 w-100 h-100 z--1`}></span>
            )}
        </section>
    )
}